<template>
    <div class="chat-container">
      <div class="chat-history" ref="chatHistory">
        <div v-for="(msg, index) in messages" :key="index" :class="['message', msg.role]">
          <strong>{{ msg.role === 'user' ? 'Tú' : 'Asistente' }}:</strong> {{ msg.content }}
        </div>
      </div>
  
      <div class="chat-input">
        <input
          v-model="userInput"
          @keyup.enter="handleSend"
          placeholder="Escribe tu mensaje..."
          :disabled="loading"
        />
        <button @click="handleSend" :disabled="loading || !userInput.trim()">Enviar</button>
      </div>
    </div>
  </template>
  
  <script>
import ChatbotService from '@/services/mlService'; // Ajusta la ruta según tu estructura

  export default {
    name: "ChatView",
    data() {
      return {
        userInput: "",
        messages: [],
        loading: false,
      };
    },
    async created() {
      this.loading = true;
      await ChatbotService.loadModel();
      this.loading = false;
    },
    methods: {
      async handleSend() {
        const input = this.userInput.trim();
        if (!input) return;
  
        this.messages.push({ role: "user", content: input });
        this.userInput = "";
        this.loading = true;
  
        const { response} = await ChatbotService.predict(input);
        this.messages.push({ role: "assistant", content: response });
  
        this.loading = false;
        this.scrollToBottom();
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const chatHistory = this.$refs.chatHistory;
          chatHistory.scrollTop = chatHistory.scrollHeight;
        });
      }
    }
  };
  </script>
  
  <style scoped>
  .chat-container {
    display: flex;
    flex-direction: column;
    max-width: 600px;
    height: 80vh;
    margin: 0 auto;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    font-family: sans-serif;
  }
  
  .chat-history {
    flex-grow: 1;
    padding: 1rem;
    overflow-y: auto;
    background-color: #f9f9f9;
  }
  
  .message {
    margin-bottom: 1rem;
  }
  
  .message.user {
    text-align: right;
    color: #333;
  }
  
  .message.assistant {
    text-align: left;
    color: #007bff;
  }
  
  .chat-input {
    display: flex;
    border-top: 1px solid #ddd;
    padding: 0.5rem;
    background: #fff;
  }
  
  .chat-input input {
    flex-grow: 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .chat-input button {
    margin-left: 0.5rem;
    padding: 0.5rem 1rem;
  }
  </style>
  